<div v-if="total > 0" ref="relQList" class="tt-c-related-questions-list">
  <div class="tt-c-related-questions-list__header tt-u-mb--md">
    <div ref="heading" class="tt-c-related-questions-list__heading" tabindex="-1" v-html="$msg('relatedQuestions.title')"></div>
  </div>

  <div class="tt-c-related-questions-list__content">
      <tt-question v-for="item in relatedQuestions"
                :isRelated="true"
                :question="item.relatedQuestion"
                :key="item.relatedQuestion.id"
                :submissionCtx="submissionCtx"
                :showBestAnswer="false"></tt-question>
  </div>
  <tt-pagination :currentPage="currentPage" @updatePage="pageChange" :total="total" :initialPageSize="initialPageSize" :pageSize="pageSize"></tt-pagination>
</div>



// WEBPACK FOOTER //
// ./src/components/related-questions-list/related-questions-list.html